import React, { useEffect, useState } from "react";
import "./Footer.css";
import logo from "../../asset/logo.jpg";
import axiosInstance from "../../api/axiosInstance";
import { useNavigate } from "react-router-dom";
import { FaFacebook, FaInstagram, FaTwitter, FaWhatsapp } from "react-icons/fa";

function Footer() {
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axiosInstance.get("categories/");
        setCategories(res.data);
      } catch (error) {
        console.log(error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <img src={logo} alt="logo" className="footer-logo" />
          <p>
            Premium quality Stickers with best offers.
            Fast delivery & secure payments.
          </p>
        </div>
        <div className="footer-section">
          <h3>Categories</h3>
          <ul>
            {categories.slice(0, 6).map((cat) => (
              <li
                key={cat.id}
                onClick={() =>
                  navigate(`/products/${cat.name}`)
                }
              >
                {cat.name}
              </li>
            ))}
          </ul>
        </div>
        <div className="footer-section">
          <h3>Contact</h3>
          <p>📍 Chennai, India</p>
          <p>📧 hello@stickyroot.in</p>
          <p>📞 +91 8870523438</p>
        </div>

        {/* <div className="footer-section">
          <h3>Follow Us</h3>
          <div className="social-icons">
            <FaFacebook />
            <FaInstagram />
            <FaTwitter />
            <FaWhatsapp />
          </div>
        </div> */}

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} stickyroot.in. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;